import { createReducer, on } from '@ngrx/store';
import * as TransactionTabActions from '../actions/transaction-tab.actions';
import { initialTransactionTabState, TransactionTabState } from '@store/models/transaction-tab.model';

export const transactionTabReducer = createReducer(
    initialTransactionTabState,
    on(TransactionTabActions.setTransactionTab, (state, { pageId, tabIndex }) => ({
        ...state,
        tabs: { ...state.tabs, [pageId]: tabIndex },
    })),
    on(TransactionTabActions.resetTransactionTab, (state, { pageId }) => {
        const tabs = { ...state.tabs };
        delete tabs[pageId];
        return { ...state, tabs };
    }),
);
